export const DeclarationCotisation = {
    path: '/declaration_cotisation',
    name: 'declaration_cotisation',
    component: () => import('@/views/Impression/DeclarationCotisation/DeclarationCotisationPage.vue'),
    children: [
        {
            path: '/contribution_declarations/add',
            name: 'contribution_declarations.add',
            component: () => import('@/views/ContributionDeclaration/Form/ContributionDeclarationForm.vue'),
            props: {addAction: true, type: 'DECLARATION_COTISATION'}
        },
        {
            path: '/contribution_declarations/edit/:id',
            name: 'contribution_declarations.edit',
            component: () => import('@/views/ContributionDeclaration/Form/ContributionDeclarationForm.vue'),
            props: {updateAction: true, type: 'DECLARATION_COTISATION'}
        },
        {
            path: '/contribution_declarations/delete/:id',
            name: 'contribution_declarations.delete',
            component: () => import('@/views/ContributionDeclaration/Form/ContributionDeclarationForm.vue'),
            props: {deleteAction: true, type: 'DECLARATION_COTISATION'}
        },
        {
            path: '/contribution_declarations/view/:id',
            name: 'contribution_declarations.view',
            component: () => import('@/views/ContributionDeclaration/Form/ContributionDeclarationForm.vue'),
            props: {viewAction: true, type: 'DECLARATION_COTISATION'}
        },
    ]
}